/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Heading } from 'sarsaparilla';

function LotteryWinnerPrompt({
    orderId,
    permitName,
    permitLocation,
    permitCategory,
    recAreaName,
    startDate,
    confirmDate,
    selectedLotteryPreference,
    divisions,
    enableLengthOfStay,
    enableGroupSize,
    handleLotteryAccept,
    handleLotteryDecline,
}) {
    const divisionID = selectedLotteryPreference.division_id;
    const lengthOfStay = selectedLotteryPreference.length_of_stay;
    const maxGroupSize = selectedLotteryPreference.group_max_size;
    return (
        <div className="rec-venue-page-right-rail">
            <div className="rec-aside-header">
                <div>Order: {orderId}</div>
            </div>
            <div className="rec-aside-body">
                <div className="right-rail-card">
                    <Heading appearance="h5">{permitName} - Permit</Heading>
                    {recAreaName && <div className="grayed">{recAreaName}</div>}
                    {permitLocation && <div className="grayed">{permitLocation}</div>}
                    {permitCategory && (
                        <div id="permit-type" className="grayed">
                            {permitCategory}
                        </div>
                    )}
                    <br />
                    <div id="permit-winner-start-date">
                        <span>
                            <b>Start Date</b>: {startDate}
                        </span>
                    </div>
                    {divisionID && (
                        <div id="permit-winner-division">
                            <span>
                                <b>Entry Location</b>: {divisions[divisionID].name}
                            </span>
                        </div>
                    )}
                    {enableLengthOfStay && (
                        <div id="permit-winner-stay-length">
                            <span>
                                <b>Length of Stay</b>: {lengthOfStay}
                            </span>
                        </div>
                    )}
                    {enableGroupSize && (
                        <div id="permit-winner-group-size">
                            <span>
                                <b>Max Group Size</b>: {maxGroupSize}
                            </span>
                        </div>
                    )}
                    <div id="permit-winner-confirm-date">
                        <span>
                            <b>Confirm Decision By</b>: {confirmDate}
                        </span>
                    </div>
                    <br />
                    <Button
                        id="permit-winner-accept-button"
                        aria-label="accept-and-register"
                        className="mb-2"
                        onClick={handleLotteryAccept}
                        size="md"
                        shouldFitContainer
                    >
                        Accept & Register
                    </Button>
                    <Button
                        className="rec-button-primary-large"
                        aria-label="decline-reservation"
                        appearance="danger"
                        onClick={handleLotteryDecline}
                        size="md"
                        shouldFitContainer
                    >
                        Decline Reservation
                    </Button>
                </div>
            </div>
        </div>
    );
}

LotteryWinnerPrompt.propTypes = {
    handleLotteryAccept: PropTypes.func,
    handleLotteryDecline: PropTypes.func,
    orderId: PropTypes.string,
    permitName: PropTypes.string,
    permitLocation: PropTypes.string,
    permitCategory: PropTypes.string,
    recAreaName: PropTypes.string,
    startDate: PropTypes.string,
    confirmDate: PropTypes.string,
    selectedLotteryPreference: PropTypes.shape({
        division_id: PropTypes.string,
        group_max_size: PropTypes.number,
        length_of_stay: PropTypes.number,
        preferred_date: PropTypes.string,
    }),
    divisions: PropTypes.object,
    enableLengthOfStay: PropTypes.bool,
    enableGroupSize: PropTypes.bool,
};
export default LotteryWinnerPrompt;
